(() => {
  'use strict';

  function animateCounter(element) {
    if (element.dataset.animated === 'true') return;

    element.dataset.animated = 'true';

    const original = element.dataset.value || element.textContent.trim();

    const match = original.match(/^(\d+)(.*)$/);

    // If it doesn't start with a number (rare case), just show it
    if (!match) {
      element.textContent = original;
      return;
    }

    const target = parseInt(match[1], 10);
    const suffix = match[2] || "";

    let current = 0;
    const duration = 1500;
    const startTime = performance.now();

    function update(now) {
      const progress = Math.min((now - startTime) / duration, 1);

      // easeOutCubic
      const eased = 1 - Math.pow(1 - progress, 3);

      current = Math.floor(target * eased);

      element.textContent = current + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        element.textContent = original;
      }
    }

    requestAnimationFrame(update);
  }

  function initEcomaStats(scope = document) {

    const sections = scope.querySelectorAll('.ecoma-stats');

    sections.forEach(section => {

      const items = section.querySelectorAll('.ecoma-stat-item');

      if (!items.length) return;

      if ('IntersectionObserver' in window) {

        const observer = new IntersectionObserver((entries) => {

          entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            const item = entry.target;

            item.classList.add('is-visible');

            const number = item.querySelector('.ecoma-stat-number');

            if (number) {
              animateCounter(number);
            }

            observer.unobserve(item);

          });

        }, {
          threshold: 0.2,
          rootMargin: "0px 0px -50px 0px"
        });

        items.forEach(item => {

          const number = item.querySelector('.ecoma-stat-number');

          if (number) {
            number.dataset.animated = "false";
          }

          observer.observe(item);

        });

      } else {

        items.forEach(item => {

          item.classList.add('is-visible');

          const number = item.querySelector('.ecoma-stat-number');

          if (number) {
            animateCounter(number);
          }

        });

      }

    });

  }

  document.addEventListener('DOMContentLoaded', function () {
    initEcomaStats();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initEcomaStats(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initEcomaStats();
  });

})();